import { DialogContext } from "@/lib/main";
import { DialogContextType } from "@/lib/main";
import { useContext } from "react";

export default function useDialog(): DialogContextType {
  const context = useContext(DialogContext);
  if (!context) {
    throw new Error("useDialog must be used within a DialogContext.Provider");
  }
  return context;
}